import { RootState } from "@/store/store";
import { infrastructureArchitectureSelectedAccountSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureSelectedAccountSelector";
import { infrastructureArchitectureSelectedRegionSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureSelectedRegionSelector";

export const infrastructureArchitectureGenerateDiagramDisabledSelector = (
  state: RootState,
) => {
  const region = infrastructureArchitectureSelectedRegionSelector(state);
  const account = infrastructureArchitectureSelectedAccountSelector(state);

  return !region || !account;
};
